import React from 'react'
import { Pressable, View } from 'react-native'
import { BG_STYLES, COLORS } from '@dehaat/dds'
import BouncyCheckbox from 'react-native-bouncy-checkbox'
import { DemoMaterialRequest } from 'app/models/RequestFlow'
import { getDemoCardApprovalState } from './demoRequestCard.utils'
import DemoRequestCardHeader from './DemoRequestCardHeader'
import DemoRequestCardSections from './DemoRequestCardSections'
import DemoRequestCardFooter from './DemoRequestCardFooter'

type Props = {
  item: DemoMaterialRequest
  styles: any
  isMultiSelectEnabled: boolean
  selectedRequestIds: number[]
  currentUserId: number | null
  roleType?: string
  canTakeApproverAction: (item: DemoMaterialRequest) => boolean
  toggleSelect: (id: number) => void
  onOpenRequest: (item: DemoMaterialRequest) => void
  onRejectRequest: (item: DemoMaterialRequest) => void
  onApproveRequest: (item: DemoMaterialRequest) => void
  getDisplayStatus: (latestStatus?: string) => string
  getStatusPillStyle: (latestStatus?: string) => any
  getStatusTextStyle: (latestStatus?: string) => any
}

const DemoMaterialRequestCard = ({
  item,
  styles,
  isMultiSelectEnabled,
  selectedRequestIds,
  currentUserId,
  roleType,
  canTakeApproverAction,
  toggleSelect,
  onOpenRequest,
  onRejectRequest,
  onApproveRequest,
  getDisplayStatus,
  getStatusPillStyle,
  getStatusTextStyle,
}: Props) => {
  const { isApprovedRequest, isApprovedByYou } = getDemoCardApprovalState(
    item,
    roleType,
    currentUserId,
  )
  const showSelect = isMultiSelectEnabled && canTakeApproverAction(item)

  return (
    <Pressable
      style={[styles.card, BG_STYLES.bgWhite]}
      onPress={() => {
        if (showSelect) {
          toggleSelect(item.id)
          return
        }
        onOpenRequest(item)
      }}
    >
      {showSelect && (
        <View style={styles.checkboxWrap}>
          <BouncyCheckbox
            isChecked={selectedRequestIds.includes(item.id)}
            onPress={() => toggleSelect(item.id)}
            size={20}
            fillColor={COLORS.primary100}
            iconStyle={styles.checkbox}
            innerIconStyle={styles.checkbox}
          />
        </View>
      )}
      <DemoRequestCardHeader
        item={item}
        styles={styles}
        getDisplayStatus={getDisplayStatus}
        getStatusPillStyle={getStatusPillStyle}
        getStatusTextStyle={getStatusTextStyle}
      />
      <DemoRequestCardSections item={item} styles={styles} />
      <DemoRequestCardFooter
        item={item}
        styles={styles}
        isApprovedRequest={isApprovedRequest}
        isApprovedByYou={isApprovedByYou}
        isMultiSelectEnabled={isMultiSelectEnabled}
        showApproverActions={canTakeApproverAction(item)}
        onRejectRequest={onRejectRequest}
        onApproveRequest={onApproveRequest}
      />
    </Pressable>
  )
}

export default DemoMaterialRequestCard
